import { useEffect, useState } from "react";
import { useFb } from "../../../utils/football";

function Row({ rank, name, flag, goals, me, indicator }) {
  return (
    <div className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm ${me ? "bg-amber-400/15 font-bold" : ""}`} data-testid={`standings-row-${rank}`}>
      <span className="w-6 text-center font-bold text-muted-foreground">{rank}</span>
      {flag ? <img src={flag} alt="" className="h-4 w-6 rounded object-cover" /> : <span className="h-4 w-6" />}
      <span className="flex-1 truncate">{name}{me ? " (you)" : ""}{indicator ? " ⭐" : ""}</span>
      <span className="font-bold wc-gold">{goals}</span>
    </div>
  );
}

export default function MiniCupStandings() {
  const fb = useFb();
  const [tab, setTab] = useState("players");
  const [players, setPlayers] = useState(null);
  const [countries, setCountries] = useState(null);
  const [myCode, setMyCode] = useState(null);

  useEffect(() => {
    (async () => {
      try { const d = await fb.get("/football/mini-cup/leaderboard/players", { limit: 100 }); setPlayers(d); } catch { setPlayers({ entries: [] }); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tab !== "countries" || countries) return;
    (async () => {
      try { const d = await fb.get("/football/mini-cup/leaderboard/countries"); setCountries(d.entries || []); setMyCode(d.my_team_code); } catch { setCountries([]); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div data-testid="minicup-standings">
      <div className="mb-3 grid grid-cols-2 gap-2">
        {["players", "countries"].map((t) => (
          <button key={t} onClick={() => setTab(t)}
            className={`rounded-lg py-2 text-sm font-bold capitalize ${tab === t ? "wc-bg-gold text-slate-900" : "border border-border bg-card text-muted-foreground"}`}
            data-testid={`standings-tab-${t}`}>{t}</button>
        ))}
      </div>

      {tab === "players" && (
        <div className="rounded-xl border border-border bg-card p-2">
          {!players ? <div className="py-6 text-center text-sm text-muted-foreground">Loading…</div>
            : (players.entries?.length || 0) === 0 ? <div className="py-6 text-center text-sm text-muted-foreground">No scores yet — be the first!</div>
            : <>
                {(players.entries || []).map((e) => <Row key={e.user_id} rank={e.rank} name={e.name} flag={e.flag_url} goals={e.total_goals} me={e.is_current_user} />)}
                {players.me && (
                  <div className="mt-1 border-t border-border pt-1">
                    <Row rank={players.me.rank} name={players.me.name} flag={players.me.flag_url} goals={players.me.total_goals} me />
                  </div>
                )}
              </>}
        </div>
      )}

      {tab === "countries" && (
        <div className="rounded-xl border border-border bg-card p-2">
          {!countries ? <div className="py-6 text-center text-sm text-muted-foreground">Loading…</div>
            : countries.map((c) => <Row key={c.code} rank={c.rank} name={c.name} flag={c.flag_url} goals={c.total_goals} indicator={c.code === myCode} />)}
        </div>
      )}
    </div>
  );
}
